import { render, staticRenderFns } from "./VEmptyState.vue?vue&type=template&id=d104046c"
import script from "./VEmptyState.vue?vue&type=script&lang=ts"
export * from "./VEmptyState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports